<nb-card>
    <nb-card-header>Are you sure you want to delete this item ?</nb-card-header>
    <nb-card-body>
        <p>Please confirm before deletion</p>
    </nb-card-body>
    <nb-card-footer>
        <button style="margin-inline-end: 1rem;" (click)="ref.close(true)" nbButton status="danger">Delete</button>
        <button nbButton status="success" (click)="ref.close(false)">Keep</button>
    </nb-card-footer>
</nb-card>